import React from "react"

export type MenuSubConsultaProdutoProps = {
    permitirVisualiarReservas: boolean
    permitirVisualiarPedidosFornecedores: boolean
    permitirVisualiarPedidosClientes: boolean
    permitirVisualiarEncomenda: boolean
    permitirVisualiarNaoEntregueExpedicao: boolean
    permitirVisualiarNaoEntregueFutura: boolean
    habilitarReservas: boolean
    habilitarEncomenda: boolean
    habilitarPedidosFornecedores: boolean
    habilitaPedidosClientes: boolean
    habilitaNaoEntregueExpedicao: boolean
    habilitaNaoEntregueFutura: boolean
    habilitarRma: boolean
    onRenderizarSubConsultaReservas: () => void
    onRenderizarSubConsultaPedidosFornecedores: () => void
    onRenderizarSubConsultaPedidosClientes: () => void
    onRenderizarSubConsultaEncomenda: () => void
    onRenderizarSubConsultaNaoEntregueExpedicao: () => void
    onRenderizarSubConsultaNaoEntregueFutura: () => void
    onSelecionadoMenu: () => void;
    onRenderizarSubConsultaRma: () => void
}

export const MenuSubConsultaProduto = (props: MenuSubConsultaProdutoProps) => {
    return (
        <>
            <h2
                id="MenuSubConsultaProduto_H2SibMenuConsultas"
            >Sub-Consultas</h2>
            <ul>


                {props.permitirVisualiarReservas && (
                    <li>
                        <a href="#" style={props.habilitarReservas ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" } : {}}
                            id="MenuSubConsultaProduto_Reservas"
                            onClick={() => { props.onRenderizarSubConsultaReservas(), props.onSelecionadoMenu(); }}>
                            Reservas
                        </a>
                    </li>
                )}


                {props.permitirVisualiarPedidosFornecedores && (
                    <li>
                        <a href="#" style={props.habilitarPedidosFornecedores ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" } : {}}
                            id="MenuSubConsultaProduto_PedidosDeFornecedores"
                            onClick={() => { props.onRenderizarSubConsultaPedidosFornecedores(), props.onSelecionadoMenu(); }}>
                            Pedidos de Fornecedores
                        </a>
                    </li>
                )}

                {props.permitirVisualiarPedidosClientes && (
                    <li>
                        <a href="#" style={props.habilitaPedidosClientes ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" } : {}}
                            id="MenuSubConsultaProduto_PedidosDeCliente"
                            onClick={() => { props.onRenderizarSubConsultaPedidosClientes(), props.onSelecionadoMenu(); }} >
                            Pedidos de Clientes
                        </a>
                    </li>
                )}

                {props.permitirVisualiarNaoEntregueExpedicao && (
                    <li>
                        <a href="#" style={props.habilitaNaoEntregueExpedicao ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" } : {}}
                            id="MenuSubConsultaProduto_NaoEntregueExpedicao"
                            onClick={() => { props.onRenderizarSubConsultaNaoEntregueExpedicao(), props.onSelecionadoMenu(); }} >
                            Não Entregue Expedição
                        </a>
                    </li>
                )}

                {props.permitirVisualiarNaoEntregueFutura && (
                    <li>
                        <a href="#" style={props.habilitaNaoEntregueFutura ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" } : {}}
                            id="MenuSubConsultaProduto_NaoEntregueFutura"
                            onClick={() => { props.onRenderizarSubConsultaNaoEntregueFutura(), props.onSelecionadoMenu(); }} >
                            Não Entregue Futura
                        </a>
                    </li>
                )}

                {props.permitirVisualiarEncomenda && (
                    <li>
                        <a href="#" style={props.habilitarEncomenda ? { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" } : {}}
                            id="MenuSubConsultaProduto_Encomenda"
                            onClick={() => { props.onRenderizarSubConsultaEncomenda(), props.onSelecionadoMenu(); }}>
                            Encomenda
                        </a>
                    </li>
                )}

                <li>
                    <a href="#"
                        id="MenuSubConsultaProduto_RMA"
                        style={props.habilitarRma
                            ? {}
                            : { cursor: "default", pointerEvents: "none", color: "rgba(110, 110, 110, 0.5)" }}
                        onClick={() => {
                            props.onRenderizarSubConsultaRma(),
                                props.onSelecionadoMenu();
                        }}>
                        RMA
                    </a>
                </li>
            </ul>
        </>
    )
}